import React from "react";
import { colors, devices } from "../../../utils/styled/_variables.styled";
import { getTagInfo } from "../../../utils/js/tags";
import useVisibility from "../../../utils/useVisibility";
import { getWidthAndHeightProps } from "../../../utils/js/widthAndHeight";
import Icon from "../../Icon/Icon";
import { ReadingTimeLabel } from "./ReadingTimeLabel";

function CardContainer({
	href, reff, ...props
}) {
	const Container = href ? 'a' : 'div'
	return <Container draggable="false" ref={reff} href={href} {...props} />
}

const iconMap = {
	slider: 	<Icon icon="button-arrow" color={colors.blue} />,
	news: <Icon icon="triangle-arrow-right" color={colors.bluegray} />
}

export const RelatedContentShadowCard = ({
	content,
	linkText,
	showHighlightedDescription,
	showDate
}) => {
	const {
		image,
		imageCrop,
		date,
		title,
		description,
		linkPath,
		contentType,
		readingTime,
		shadow
	} = content?.searchResultItemDTO || {}
	const { overviewPagePath, overviewPageTarget } = getTagInfo(contentType, content.tagsInfo) || {}
	const handleTagClick = e => {
		e.stopPropagation()
		e.preventDefault()
		window.open(overviewPagePath, overviewPageTarget)
	}
	const [ref, isVisible] = useVisibility()
	let articleDate = date
  if(date == null || date ==  undefined){
		articleDate = "00.00.0000";
		showDate = false;
  }
	return <CardContainer className="rel-content__card--shadow" reff={ref} href={linkPath}>
		<div className={`rel-content__card--shadow__top rel-content__card--shadow__top--bglinear__${shadow || 'none'}`}>
			{isVisible && imageCrop && Object.keys(imageCrop).length ? <picture>
				<source media={devices.desktop} srcSet={imageCrop.newsDesktop} />
				<source media={devices.tablets} srcSet={imageCrop.newsTablet} />
				<source media={devices.mobile} srcSet={imageCrop.newsMobile} />
				<img {...getWidthAndHeightProps(ref)} className="rel-content__card--shadow__top__bg" src={imageCrop.newsDesktop} alt={title} />
			</picture> : <img {...getWidthAndHeightProps(ref)} alt={title} className="rel-content__card--shadow__top__bg"
				src={(isVisible && image) ? image : 'https://placehold.co/644x644?text=Missing+Image'}
			/>}
			<ReadingTimeLabel readingTime={readingTime} />
		</div>
		<div className="rel-content__card--shadow__body">
			<div>
				{<span className="rel-content__card--shadow__body__date" style={{ visibility: showDate ? "visible" : "hidden" }}>{articleDate?.replace(/\./g, "/")}</span>}
				<div className="rel-content__card--shadow__body__title">
					<h3>{title}</h3>
				</div>
				{showHighlightedDescription && <div className="rel-content__card--shadow__body__description">
					<p>{description}</p>
				</div>}
			</div>
			<div className='rel-content__card--shadow__body__bottom'>
				{contentType ? <span className='rel-content__card--shadow__body__bottom__tag' onClick={handleTagClick}>{contentType.toUpperCase()}</span> : <span />}
				<div className="rel-content__card--shadow__body__bottom__link">
					{linkText}
					<Icon color={colors.bluegray} icon="triangle-arrow-right" />
				</div>
			</div>
		</div>
	</CardContainer>
}

export const RelatedContentOverlayCard = ({
	content,
	linkText,
	showHighlightedDescription,
	showDate,
	type
}) => {
	const {
		highlighted,
		manualHighlight,
		searchResultItemDTO,
	} = content;
	const {
		image,
		imageCrop,
		fittedImage,
		date,
		title,
		description,
		linkPath,
		contentType,
		readingTime,
	} = searchResultItemDTO || {};
	const { overviewPagePath, overviewPageTarget } = getTagInfo(contentType, content.tagsInfo) || {}
	const handleTagClick = e => {
		e.stopPropagation()
		e.preventDefault()
		window.open(overviewPagePath, overviewPageTarget)
	}
	const [ref, isVisible] = useVisibility()
	let articleDate = date
	if(date == null || date ==  undefined){
		articleDate = "00.00.0000"
		showDate = false;
	}
	return <CardContainer className="rel-content__card--overlay" reff={ref} href={linkPath}>
		<div className={`rel-content__card--overlay__bgimg ${fittedImage ? "rel-content__card--overlay__fitted-img" : "" }`}>
			{fittedImage && <img alt={title} src={fittedImage}/>}
			{isVisible && imageCrop && !fittedImage && Object.keys(imageCrop).length ? <picture>
				<source media={devices.desktop} srcSet={imageCrop.sliderDesktop} />
				<source media={devices.tablets} srcSet={imageCrop.sliderTablet} />
				<source media={devices.mobile} srcSet={imageCrop.sliderTablet} />
				<img {...getWidthAndHeightProps(ref)} src={imageCrop.sliderDesktop} alt={title} />
			</picture> : isVisible && !fittedImage && <img {...getWidthAndHeightProps(ref)} alt={title}
				src={image ? image : "https://placehold.co/644x644?text=Missing+Image"}
			/>}
		</div>
		<div className="rel-content__card--overlay__slider">
			<div className="rel-content__card--overlay__header">
				{contentType && <span className="rel-content__card--overlay__tag" onClick={handleTagClick}>
					{contentType.toUpperCase()}
				</span>}
				{(highlighted || manualHighlight) && <span className="rel-content__card--overlay__tag">HIGHLIGHT</span>}
				<ReadingTimeLabel readingTime={readingTime} />
			</div>
			<div className="rel-content__card--overlay__body">
				<div className="rel-content__card--overlay__date" style={{ visibility: showDate ? "visible" : "hidden" }}>{articleDate?.replace(/\./g, "/")}</div>
				<div className="rel-content__card--overlay__title"><h3>{title}</h3></div>
				{showHighlightedDescription && <div className="rel-content__card--overlay__description">
					<p>{description}</p>
				</div>}
				<div className="rel-content__card--overlay__link">
					{linkText}
					{iconMap[type] || <></>}
				</div>
			</div>
		</div>
	</CardContainer>
}
